import { pickedApiRequest } from './request'

/**
 * Per-candidate billing: what the organisation pays, the card on file and
 * the card setup flow. Completing setup enables paid unlocking and can retry
 * an outstanding invoice; stopping billing can invoice accrued usage.
 */
export default {
  /**
   * @return {Object} summary (model, band, currency, amounts, free allowance, card, block, this month)
   */
  show () {
    return pickedApiRequest.get('assessment/candidate-billing')
      .then(response => response.data.data)
  },

  /**
   * Public pricing (bands, currencies, free allowance, suggested currency).
   *
   * @return {Object}
   */
  pricing () {
    return pickedApiRequest.get('assessment/candidate-pricing')
      .then(response => response.data.data)
  },

  /**
   * @param {string} currency
   * @return {Object} clientSecret, setupIntentId, currency, band, unitAmount
   */
  createSetupIntent (currency) {
    return pickedApiRequest.post('assessment/candidate-billing/setup-intent', { currency })
      .then(response => response.data.data)
  },

  /**
   * @param {Object} data setupIntentId, setupIntentClientSecret, currency
   * @return {Object}
   */
  completeSetup (data) {
    return pickedApiRequest.post('assessment/candidate-billing/setup-complete', data)
      .then(response => response.data.data)
  },

  removeCard () {
    return pickedApiRequest.post('assessment/candidate-billing/remove-card', { confirmed: true })
      .then(response => response.data.data)
  },

  /**
   * What the self-serve switch would do for this annual customer
   *
   * @return {Object} available, plan_name, annual_fee, currency, current_period_end, unused_credits, band, unit_amount, refund, ends_now
   */
  switchPreview () {
    return pickedApiRequest.get('assessment/candidate-billing/switch-preview')
      .then(response => response.data.data)
  },

  /**
   * The switch itself; the server refuses it without confirmation
   */
  switchFromAnnual () {
    return pickedApiRequest.post('assessment/candidate-billing/switch', { confirmed: true })
      .then(response => response.data.data)
  }
}
